import { Grid ,Button, Typography, Card} from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Iframe from 'react-iframe'
import React from 'react'
import colors from '../../../colors';
import { texts } from '../../../general/texts';
import { useNavigate } from 'react-router-dom';

const TopUpLocations = () => {

    const navigate = useNavigate()

  return (
    <Grid container justifyContent={'center'} direction={'column'} >
        <Grid container pb={3} pt={3}>    
            <Grid item md={4.9} xs={6}>
                <Button disableRipple={true} onClick={()=> { navigate(-1)}} sx={{textTransform:'none', borderRadius:'10px',":hover":{background:colors.lightOrange}}} >
                    <ArrowBackIosNewIcon color='warning'/><Typography sx={{color:colors.orange, fontFamily:'GerberaLight'}}>{texts["button-back"]}</Typography>
                </Button>
            </Grid>
        </Grid> 
        <Grid item>
            <Iframe url={'https://intern-apps.easypay.al/EasyPayAgents/map/pos'}
                width='65%'
                height="700vh"
                id="myId"
                className="myClassname"
                display="initial"
                position="relative"
            />
        </Grid>
    </Grid>
  )
}

export default TopUpLocations